import React from "react";
import { Link } from "react-router-dom";
import {
  consolidateEventState,
  translateEventState,
  showDate,
  getGMapLink,
  getNewEventId,
} from "../../utils/event.utils";
import {
  buildStationImageEntry,
  canShowStations,
  getHanEventTypes,
  getStationImageUploadKey,
  isHanProject,
  isStationEvent,
} from "../../utils/station.utils";
import {
  exportEventToJsonWithMessage,
  exportEventsToCSV,
} from "../../utils/export.utils";
import Style from "../../styles/Pages.module.css";
import withAuthorization from "../HOC/with.authorization";
import { IFirebaseAuthUser } from "../../interfaces/authentication.interfaces";
import AuthenticationValidatorLogic from "../../logic/authenticationValidatorLogic";
import * as ROUTES from "../../constants/routes";
import AppContext from "../../context/app.context";
import { BUTTON_PROPS } from "../../constants/general";
import {
  Button,
  Table,
  Menu,
  Dropdown,
  Icon,
  Modal,
  Form,
  Radio,
  Checkbox,
  Input,
  Select,
} from "antd";
import {
  IEventService,
  ILiaEventService,
  IServices,
  ISviEventService,
} from "../../interfaces/services.interfaces";
import {
  IEventProperties,
  ILocation,
  IServerEvent,
} from "../../interfaces/map.interfaces";
import moment from "moment";
import UploadImage from "../Map/UploadImage";
import { UploadFile } from "antd/lib/upload/interface";
import HistoryModal from "./HistoryModal";
import { SearchOutlined } from "@ant-design/icons";

interface IProps {}

interface IState {
  locations: ILocation[];
  events: IServerEvent[];
  filteredEvents: IServerEvent[];
  refreshCounter: number;
  ModalText: string;
  visible: boolean;
  confirmLoading: boolean;
  newEventComment: string;
  newEventData: any;
  newEventState: string;
  currentEventState: string;
  //for types
  currentTypeState: string;
  newTypeState: string;
  currentSubTypeState: string;
  newSubTypeState: string;
  subTypeEnabled: boolean;
  userEmail: string;
  types: string[];
  subTypes: string[];
  detections: string[];
  markersEnabled: boolean;
  imageFile: UploadFile;
  showEventHistory: boolean;
  historyEvent?: IServerEvent | null;
  eventsFilter: {
    state: ("new" | "active" | "only report change" | "do not report")[];
    reportType: ("Processed Reports" | "Edited Reports")[];
    detectedBy: ("Helicopter" | "Drone" | "Satellite" | "Others")[];
    type: string[];
    eventFilterType?: "Latest" | "By Supervision" | "Oldest" | null;
    dateFrom?: Date;
    dateTo?: Date;
  };
}

const onArchivePage = function (): boolean {
  return window.location.pathname.indexOf("/events-archive") === 4;
};

const { Option } = Select;
class EventsPage extends React.Component<IProps, IState> {
  static contextType = AppContext;

  private services: IServices;
  public subTypeEnabled: boolean;
  private lastFetchedProjectsApp: string | null = null;
  private eventsFetchGeneration = 0;

  getProjectsApp(): string | null {
    const fromContext = (this.context as any)?.projects?.app;
    const fromWindow = (window as any)?._projects?.app;
    const app = fromContext ?? fromWindow;
    return typeof app === "string" ? app : null;
  }

  // Generic GIS projects often omit `app` (only svi/red set it). Use "default" so
  // we still fetch via eventService — same fallback the map uses.
  getProjectsAppKey(): string {
    return this.getProjectsApp() ?? "default";
  }

  getEventService(): IEventService | ISviEventService | ILiaEventService {
    const projectApp = this.getProjectsApp();
    if (projectApp === "svi") {
      return this.services.sviEventService;
    }
    if (projectApp === "red") {
      return this.services.liaEventService;
    }
    return this.services.eventService;
  }

  constructor(props: any, context: any) {
    super(props);

    this.services = context.services;

    this.state = {
      locations: [],
      events: [],
      filteredEvents: [],
      refreshCounter: 0,
      ModalText: "Content of the modal",
      visible: false,
      confirmLoading: false,
      newEventComment: "",
      newEventData: [],
      newEventState: "",
      currentEventState: "",
      currentTypeState: "",
      newTypeState: "",
      currentSubTypeState: "",
      newSubTypeState: "",
      subTypeEnabled: false,
      userEmail: "",
      types: [],
      subTypes: [],
      detections: [],
      markersEnabled: false,
      imageFile: null,
      showEventHistory: false,
      historyEvent: null,
      eventsFilter: {
        state: ["active", "only report change", "do not report", "new"],
        reportType: ["Edited Reports", "Processed Reports"],
        detectedBy: ["Drone", "Helicopter", "Satellite", "Others"],
        type: [],
        eventFilterType: "Latest",
        dateFrom: undefined,
        dateTo: undefined,
      },
    };
  }

  componentDidMount() {
    this.refreshUserAndProjectMetadata();
    this.scheduleEventsLoad();
  }

  componentDidUpdate() {
    this.scheduleEventsLoad();
  }

  scheduleEventsLoad() {
    const projectApp = this.getProjectsAppKey();
    if (projectApp === this.lastFetchedProjectsApp) {
      return;
    }
    this.fetchEventsForProject(projectApp);
  }

  refreshUserAndProjectMetadata() {
    this.services.userService.getMyData().then((data: any) => {
      this.setState({
        userEmail: data?.data.email,
      });
    });

    this.services.projectService
      .getMyData()
      .then((data: any) => {
        const project = data?.data?.[0];
        console.log(project?.detection);

        // AppContext Provider is initialized with projects: null; keep local copies in sync
        // so service selection and other consumers see the loaded project.
        if (project != null) {
          (window as any)._projects = project;
          if (this.context) {
            (this.context as any).projects = project;
          }
        }

        this.setState({
          types: isHanProject(project?.id) && canShowStations()
            ? getHanEventTypes(project?.types)
            : project?.types,
          subTypes: project?.subTypes,
          detections: project?.detection,
          markersEnabled: project?.markersEnabled,
          subTypeEnabled: project?.subTypeEnabled,
        });

        // Re-evaluate fetch after project metadata arrives (may switch svi/red vs default).
        this.scheduleEventsLoad();
      })
      .catch((error: any) => {
        console.log("error getting project data!");
      });
  }

  fetchEventsForProject(projectApp: string) {
    const fetchGeneration = ++this.eventsFetchGeneration;

    this.getEventService()
      .getMyData()
      .then((data: any) => {
        if (fetchGeneration !== this.eventsFetchGeneration) {
          return;
        }
        if (this.getProjectsAppKey() !== projectApp) {
          return;
        }

        console.log("got location data:");
        console.log(data);
        const locations: ILocation[] = data?.data || [];

        this.lastFetchedProjectsApp = projectApp;
        this.setState({
          locations,
          events: locations.flatMap((l) => l.events || []),
          filteredEvents: locations.flatMap((l) => l.events || []),
        });

        setTimeout(() => this.applyEventFilters(), 50);
      })
      .catch((error: any) => {
        if (fetchGeneration !== this.eventsFetchGeneration) {
          return;
        }
        console.log("error fetching event data from API");
        console.log(error);
        (window as any).encounteredError = true;
      });
  }

  refreshData() {
    this.refreshUserAndProjectMetadata();
    this.lastFetchedProjectsApp = null;
    this.fetchEventsForProject(this.getProjectsAppKey());
  }

  updateEventState(e) {
    this.setState({
      newEventState: e.target.value,
    });
  }
  updateTypeState(value) {
    this.setState({
      newTypeState: value,
    });
  }

  updateSubTypeState(value) {
    this.setState({
      newSubTypeState: value,
    });
  }

  updateEdit(
    previousEvent: IServerEvent,
    newType: string,
    newSubType: string,
    newState: string,
    newComment: string,
    author: string
  ) {
    if (!newComment) {
      if (newType != previousEvent.properties.subType) {
        newComment = `Type: ${newType}\t`;
      }
      if (newState != previousEvent.properties.state) {
        newComment = newComment + `State: ${newState}`;
      }
    }
    

    previousEvent.properties.id = getNewEventId(previousEvent.properties.id);
    const stationEvent = isStationEvent(previousEvent.properties);
    const existingImages = previousEvent.properties.images || [];

    if (stationEvent) {
      previousEvent.properties.image = "";
      if (this.state.imageFile) {
        const uploadKey = getStationImageUploadKey(
          previousEvent.properties.id,
          existingImages
        );
        previousEvent.properties.images = [
          ...existingImages,
          buildStationImageEntry(
            uploadKey,
            new Date().toISOString().split("T")[0],
            newComment || this.state.imageFile.name || uploadKey,
            author
          ),
        ];
      } else {
        previousEvent.properties.images = [...existingImages];
      }
    } else {
      previousEvent.properties.image = this.state.imageFile
        ? previousEvent.properties.id + ".png"
        : "";
    }

    this.services.eventService.updateEvent(
        previousEvent,
        newType,
        newSubType,
        newState,
        newComment,
        author
      )
      .then(() => {
        if (this.state.imageFile?.originFileObj) {
          const uploadKey = stationEvent
            ? previousEvent.properties.images?.[
                previousEvent.properties.images.length - 1
              ]?.key || `${previousEvent.properties.id}.png`
            : previousEvent.properties.image;
          this.services.imageService.uploadImage(
            this.state.imageFile.originFileObj as File,
            uploadKey
          );
        }
        this.refreshData();
      });
  }

  updateNav() {
    window.setTimeout(function () {
      if ((window as any)._appIndex) {
        (window as any)._appIndex.forceUpdate();
      }
    }, 10);
    window.setTimeout(function () {
      if ((window as any)._appIndex) {
        (window as any)._appIndex.forceUpdate();
      }
    }, 1000);
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = () => {
    this.setState({
      ModalText: "The modal will be closed after two seconds",
      confirmLoading: true,
    });
    this.updateEdit(
      this.state.newEventData,
      this.state.newTypeState,
      this.state.newSubTypeState,
      this.state.newEventState,
      this.state.newEventComment,
      this.state.userEmail
    );
    setTimeout(() => {
      this.setState({
        visible: false,
        confirmLoading: false,
      });
    }, 2000);
  };

  handleCancel = () => {
    this.setState({
      visible: false,
      newEventComment: "",
      newEventState: "",
      currentEventState: "",
      newTypeState: "",
      currentTypeState: "",
      newSubTypeState: "",
      currentSubTypeState: "",
    });
  };

  updateEventComment(e) {
    this.setState({ newEventComment: e.target.value });
  }

  setFile = async (file: UploadFile) => {
    this.setState({ imageFile: file });
  };

  setCommentData(newEvent: any) {
    Object.assign(this.state.newEventData, newEvent);
  }

  options(options: string[]) {
    let optionsArr = [];

    for (let i = 0; i < options.length; i++) {
      optionsArr.push(
        <Option key={options[i] + "_" + i} value={options[i]}>
          {options[i]}
        </Option>
      );
    }

    return optionsArr;
  }

  onTableChange = (pagination, filters, sorter) => {
    // Always reapply filters to ensure consistency
    // Pagination and sorting should NOT reset filters
    this.applyEventFilters();
  };

  filterText = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
    return (
      <span style={{ display: "flex" }}>
        <Input
          autoFocus
          placeholder="Type text here"
          value={selectedKeys[0]}
          onChange={(e) => {
            setSelectedKeys(e.target.value ? [e.target.value] : []);
          }}
          onPressEnter={() => {
            confirm();
          }}
          onBlur={() => {
            confirm();
          }}
        ></Input>
        <Button
          onClick={() => {
            confirm();
          }}
          type="primary"
        >
          Search
        </Button>
        <Button
          onClick={() => {
            clearFilters();
          }}
          type="danger"
        >
          Reset
        </Button>
      </span>
    );
  };

  // Ant Design only applies column search when onFilter is defined.
  filterByText = (dataIndex: string) => (value: any, record: any) =>
    String(record?.[dataIndex] ?? "")
      .toLowerCase()
      .includes(String(value).toLowerCase());

  applyEventFilters = () => {
    const { locations, eventsFilter } = this.state;
    const isArchivePage = onArchivePage();

    if (isArchivePage) {
      this.setState({
        filteredEvents: locations.flatMap((location) => location.events || []),
      });
      return;
    }

    const filtered = locations.map(loc => {
      if (!loc?.events?.length) return null;

      const validEvents = loc.events.filter((e) => e?.properties?.date);
      if (!validEvents.length) return null;

      const sorted = [...validEvents].sort(
        (a, b) => new Date(b.properties.date).getTime() - new Date(a.properties.date).getTime()
      );

      const check = (event) => {
        const p = event?.properties;
        if (!p?.date) return false;

        const date = new Date(p.date);

        if (eventsFilter.dateFrom && date < eventsFilter.dateFrom) return false;
        if (eventsFilter.dateTo && date > eventsFilter.dateTo) return false;

        const state = consolidateEventState(p.state || "");
        if (!eventsFilter.state.includes(state as any)) return false;

        const isProcessed = p.author?.endsWith("@supervision.earth");
        if (eventsFilter.reportType.length === 1) {
          if (eventsFilter.reportType.includes("Processed Reports") && !isProcessed) return false;
          if (eventsFilter.reportType.includes("Edited Reports") && isProcessed) return false;
        }

        const detectedByMap = { h:"Helicopter", d:"Drone", s:"Satellite", i:"Others" };
        let detectedByValue: string | undefined;
        
        if (p.detectedBy) {
          detectedByValue = p.detectedBy;
        } else {
          const detectedByFlagMatches = p.id?.match(/_\w{1}_/gi);
          const detectedByFlag = detectedByFlagMatches && detectedByFlagMatches.length > 0
            ? detectedByFlagMatches.pop().replace(/_/g, "")
            : "i";
          detectedByValue = detectedByMap[detectedByFlag];
        }
        
        if (!detectedByValue || !eventsFilter.detectedBy.includes(detectedByValue as any)) return false;

        if (eventsFilter.type.length && !eventsFilter.type.includes(p.type)) return false;

        return true;
      };

      if (eventsFilter.eventFilterType === "Oldest") {
        for (let i = sorted.length - 1; i >= 0; i--) {
          if (check(sorted[i])) return sorted[i];
        }
        return null;
      }
      if (eventsFilter.eventFilterType === "By Supervision") {
        for (const event of sorted) {
          if (
            event.properties.author?.includes("@supervision.earth") &&
            check(event)
          ) {
            return event;
          }
        }
        return null;
      }
      for (const event of sorted) {
        if (check(event)) return event;
      }
      return null;
    })
    .filter(Boolean);

    this.setState({ filteredEvents: filtered });
  };

  render() {
    // state counter to enable refreshing this component
    const refresh = () =>
      this.setState({ refreshCounter: this.state.refreshCounter + 1 });

    // as long as the user data has not yet been retrieved...
    if ((this.context as any)?.userData == null) {
      // ... refresh this component once a second
      window.setTimeout(refresh, 1000);
    }

    if (this.lastFetchedProjectsApp == null) {
      window.setTimeout(() => this.scheduleEventsLoad(), 500);
    }

    let language = (this.context as any)?.userData?.language;
    const isArchivePage = onArchivePage();
    let tableRows = [];
    let events = this.state.filteredEvents;

    const columns: any = [
      {
        title: language === "de" ? "Ereignis-ID" : "Event ID",
        dataIndex: "id",
        key: "id",
        sorter: (a, b) => (a.id || "").localeCompare(b.id || ""),
        sortDirections: ["descend", "ascend"],
        filterDropdown: this.filterText,
        filterIcon: () => <Icon type="search" theme="outlined" />,
        onFilter: this.filterByText("id"),
      },
      {
        title: language === "de" ? "Code" : "Code",
        dataIndex: "code",
        key: "code",
        sorter: (a, b) => (a.code || "").localeCompare(b.code || ""),
        defaultSortOrder: "ascend",
        sortDirections: ["ascend"],
        filterDropdown: this.filterText,
        filterIcon: () => <SearchOutlined />,
        onFilter: this.filterByText("code"),
        onHeaderCell: () => ({
          onClick: (e) => e.preventDefault(), // Prevent clicking the header to sort
        }),
      },{
        title: language === "de" ? "Area" : "Area",
        dataIndex: "area",
        key: "area",
        sorter: (a, b) => (a.area || "").localeCompare(b.area || ""),
        sortDirections: ["descend", "ascend"],
        filterDropdown: this.filterText,
        filterIcon: () => <Icon type="search" theme="outlined" />,
        onFilter: this.filterByText("area"),
      },

      {
        title: language === "de" ? "Letztes Update" : "Last Update",
        dataIndex: "date",
        key: "date",
        sorter: (a: IEventProperties, b: IEventProperties) =>
          moment(a.date).unix() - moment(b.date).unix(),
        sortDirections: ["descend", "ascend"],
        filterDropdown: this.filterText,
        filterIcon: () => <Icon type="search" theme="outlined" />,
        onFilter: this.filterByText("date"),
      },
      {
        title: language === "de" ? "Status" : "State",
        dataIndex: "state",
        key: "state",
        sorter: isArchivePage
          ? null
          : (a: IEventProperties, b: IEventProperties) =>
              (a.state || "").localeCompare(b.state || ""),
        filters: isArchivePage
          ? []
          : [
              {
                text: language === "de" ? "aktiv" : "active",
                value: language === "de" ? "aktiv" : "active",
              },
              {
                text:
                  language === "de"
                    ? "nur Änderung melden"
                    : "only report change",
                value:
                  language === "de"
                    ? "nur Änderung melden"
                    : "only report change",
              },
              {
                text: language === "de" ? "nicht mehr melden" : "do not report",
                value:
                  language === "de" ? "nicht mehr melden" : "do not report",
              },
              {
                text: language === "de" ? "archiviert" : "archived",
                value: language === "de" ? "archiviert" : "archived",
              },
            ],
        onFilter: (value, record) => record.state?.includes(value),
        sortDirections: isArchivePage ? null : ["descend", "ascend"],
        filterDropdown: this.filterText,
        filterIcon: () => <Icon type="search" theme="outlined" />,
      },
      {
        title: language === "de" ? "Kommentar" : "Comment",
        dataIndex: "comment",
        filterDropdown: this.filterText,
        filterIcon: () => <Icon type="search" theme="outlined" />,
        onFilter: this.filterByText("comment"),
      },
      {
        title: "CH4",
        dataIndex: "CH4",
        hidden: !this.state.detections.includes("methane"),
      },
      {
        title: "Pipeline Number",
        dataIndex: "markerName",
        hidden: !this.state.markersEnabled,
        sorter: (a, b) =>
          (a.markerName || "").localeCompare(b.markerName || ""),
        sortDirections: ["descend", "ascend"],
        filterDropdown: this.filterText,
        filterIcon: () => <Icon type="search" theme="outlined" />,
        onFilter: this.filterByText("markerName"),
      },
      {
        title: language === "de" ? "Author" : "Author",
        dataIndex: "author",
        filterDropdown: this.filterText,
        filterIcon: () => <Icon type="search" theme="outlined" />,
        onFilter: this.filterByText("author"),
      },
      {
        title: language === "de" ? "Aktionen" : "Actions",
        dataIndex: "actions",
        align: "center",
      },
      {
        title: "SubType",
        dataIndex: "subType",
        filterDropdown: this.filterText,
        filterIcon: () => <Icon type="search" theme="outlined" />,
        onFilter: this.filterByText("subType"),
        hidden: true,
      },
    ].filter((a) => !a.hidden);

    let filteredColumns = []
    
    if (this.context.projects?.app === "svi") {
      filteredColumns = columns.filter(
      (column) => column.dataIndex !== "id"
    )}else if (this.context.projects?.app === "red"){
      filteredColumns = columns.filter(
      (column) => column.dataIndex !== "code")
    } else {
      filteredColumns = columns.filter(
      (column) => column.dataIndex !== "code" && column.dataIndex !== "area")
    }


    for (let i = 0; i < events.length; i++) {
      let id = events[i]?.properties?.id;

      let eventType = events[i]?.properties?.type;

      let subType = events[i]?.properties.subType;

      let eventDate = showDate(events[i]?.properties?.date);

      let eventcode = events[i]?.properties?.code
      let eventArea = events[i]?.properties?.area

      let eventState = events[i]?.properties?.state;
      eventState = consolidateEventState(eventState);

      if (isArchivePage) {
        // on events archive page, only show archived events
        if (eventState !== "archived") {
          continue;
        }
      } else {
        // on events page, do not show events of certain types
        if (
          eventState === "removed" ||
          eventState === "observe"
        ) {
          continue;
        }
      }

      // the event state printed in human-friendly language
      let eventStateLang = translateEventState(eventState, language);

      let eventComment = events[i]?.properties?.comment;

      let linkTarget =
        ROUTES.MAP.route + "?location=" + events[i]?.properties?.locationId;

      //Show Events History
      const showEventsHistory = (event: IServerEvent) => {
        this.setState({
          showEventHistory: true,
          historyEvent: event,
        });
        console.log(event, this.state);
      };

      const actionsMenu = (
        <Menu style={{ textAlign: "center" }}>
          <Menu.Item key="0">
            <Link to={linkTarget} onClick={this.updateNav}>
              {language === "de" ? "Anzeigen" : "View"}
            </Link>
          </Menu.Item>
          <Menu.Item
            key="1"
            onClick={() => {
              exportEventToJsonWithMessage({
                properties: events[i].properties,
                ...events[i].geometry,
              });
            }}
            hidden={eventState === "deleted"}
          >
            {language === "de" ? "Exportieren" : "Export"}{" "}
            <Icon type="export" />
          </Menu.Item>
          {this.context.projects?.app === "svi" || this.context.projects?.app === "red" ? null : <Menu.Item
            key="2"
            onClick={() => {
              this.showModal();
              this.setCommentData(events[i]);
              this.setState({
                newEventState: events[i].properties.state,
                currentEventState: events[i].properties.state,
                newTypeState: events[i].properties.type,
                currentTypeState: events[i].properties.type,
                newSubTypeState: events[i].properties.subType,
                currentSubTypeState: events[i].properties.subType,
              });
            }}
          >
            {language === "de" ? "Bearbeiten" : "Edit"} <Icon type="edit" />
          </Menu.Item>}
          
          <Menu.Item
            key="3"
            onClick={() => {
              window.open(getGMapLink(events[i].geometry.coordinates));
            }}
          >
            {language === "de"
              ? "Navigieren auf Google Maps "
              : "Navigate on Google Maps "}
            <Icon type="pushpin" />
          </Menu.Item>
          <Menu.Item
            key={"4"}
            onClick={showEventsHistory.bind(null, events[i])}
          >
            {language === "de" ? "Verlauf anzeigen" : "View History"}
          </Menu.Item>
        </Menu>
      );

      tableRows.push({
        key: i + 1,
        id: isStationEvent(events[i]?.properties) ? "" : id,
        code:eventcode,
        area:eventArea,
        type: eventType,
        date: eventDate,
        state: eventStateLang,
        subType: subType,
        comment: eventComment,
        CH4: events[i].properties.CH4,
        markerName: events[i].properties.markerName,
        author: events[i].properties.author,
        actions: [
          <Button
            className={Style.mapTooltipButton}
            {...BUTTON_PROPS}
            size="small"
            key="1"
          >
            <Dropdown
              overlay={actionsMenu}
              trigger={["click", "hover"]}
              placement="bottomCenter"
            >
              <a
                className="ant-dropdown-link"
                onClick={(e) => e.preventDefault()}
              >
                <Icon type="caret-down" />
              </a>
            </Dropdown>
          </Button>,
        ],
      });
    }

    const exportAsCSV = (ifOnArchivePage) => {
      let eventsToExport = [];
      if (ifOnArchivePage) {
        for (let i = 0; i < this.state.filteredEvents.length; i++) {
          if (this.state.filteredEvents[i]?.properties?.state === "archived") {
            eventsToExport.push(this.state.filteredEvents[i]?.properties);
          }
        }
      } else {
        for (let i = 0; i < this.state.filteredEvents.length; i++) {
          if (this.state.filteredEvents[i]?.properties?.state !== "archived") {
            eventsToExport.push(this.state.filteredEvents[i]?.properties);
          }
        }
      }
      exportEventsToCSV(eventsToExport);
    };

    let title = "Events";
    if (language === "de") {
      title = "Ereignisse";
    }
    if (isArchivePage) {
      if (language === "de") {
        title = "Archiv der Ereignisse";
      } else {
        title = "Events Archive";
      }
    }

    const stateCommentForm = () => (
      <Form>
        <Form.Item label={language === "de" ? "Status" : "State"}>
          <Radio.Group
            defaultValue={this.state.newEventState}
            onChange={(e) => this.updateEventState(e)}
            value={this.state.newEventState}
          >
            <Radio.Button value="active">
              {language === "de" ? "Aktiv" : "Active"}
            </Radio.Button>
            <Radio.Button value="only report change">
              {language === "de" ? "Nur Änderung Melden" : "Only Report Change"}
            </Radio.Button>
            <Radio.Button value="archived">
              {language === "de" ? "Archiv" : "Archive"}
            </Radio.Button>
            <Radio.Button value="do not report">
              {language === "de" ? "Nicht Mehr Melden" : "Do Not Report"}
            </Radio.Button>
          </Radio.Group>
        </Form.Item>
        <Form.Item label={language === "de" ? "Typ" : "Type"}>
          <Select
            style={{ width: 200 }}
            defaultValue={this.state.newTypeState}
            onChange={(value) => this.updateTypeState(value)}
            value={this.state.newTypeState}
          >
            {this.options(this.state.types)}
          </Select>
        </Form.Item>
        <span hidden={!this.state.subTypeEnabled} style={{ color: "black" }}>
          <Form.Item label={language === "de" ? "Sub Typ" : "SubType"}>
            <Select
              style={{ width: 200 }}
              defaultValue={this.state.newSubTypeState}
              onChange={(value) => this.updateSubTypeState(value)}
              value={this.state.newSubTypeState}
            >
              {this.options(this.state.subTypes)}
            </Select>
          </Form.Item>
        </span>
        <Form.Item label={language === "de" ? "Kommentar" : "Comment"}>
          <Input
            placeholder={
              language === "de"
                ? "Schreiben Sie Ihren Kommentar..."
                : "Write your comment..."
            }
            value={this.state.newEventComment}
            onChange={(e) => this.updateEventComment(e)}
          />
        </Form.Item>
      </Form>
    );

    const getLabel = (option: string) => {
      if (language === "de") {
        switch (option) {
          case "active": return "Aktiv";
          case "only report change": return "Nur Änderungen melden";
          case "do not report": return "Nicht melden";
          case "Helicopter": return "Helikopter";
          case "Drone": return "Drohne";
          case "Satellite": return "Satellit";
          case "Others": return "Andere";
          case "Processed Reports": return "Unbearbeitete Meldungen";
          case "Edited Reports": return "Bearbeitete Meldungen";
        }
      }
      return option;
    };

    return (
      <div className={Style.formContainer}>
        <h2>{title}</h2>

        <Table
          columns={filteredColumns}
          dataSource={tableRows}
          onChange={(pagination, filters, sorter) =>
            this.onTableChange(pagination, filters, sorter)
          }
        />

        {/* === FILTER PANEL - HORIZONTAL LAYOUT === */}
        {!isArchivePage && <div style={{
          marginTop: "25px",
          padding: "24px",
          background: "#042944",
          color: "white",
          borderRadius: "8px",
          width: "100%",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)"
        }}>
          <h3 style={{marginBottom:"20px", fontSize:"18px", fontWeight:600}}>{language === "de" ? "Events filtern" : "Events Filter"}</h3>
          
          {/* Main horizontal container */}
          <div style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "24px",
            alignItems: "flex-start"
          }}>
            {/* Date Range Section */}
            <div style={{
              flex: "0 0 auto",
              minWidth: "280px",
              padding: "16px",
              background: "rgba(255, 255, 255, 0.05)",
              borderRadius: "6px",
              border: "1px solid rgba(255, 255, 255, 0.1)"
            }}>
              <h4 style={{margin:"0 0 12px 0", fontSize:"14px", fontWeight:500, color:"#87CEEB"}}>{language === "de" ? "Datum" : "Date"}</h4>
              <div style={{display:"flex", gap:"8px", flexDirection:"column"}}>
                <Input
                  type="date"
                  style={{ width: "100%", background:"rgba(255,255,255,0.1)", border:"1px solid rgba(255,255,255,0.2)", color:"white" }}
                  value={this.state.eventsFilter.dateFrom ? new Date(this.state.eventsFilter.dateFrom).toISOString().split('T')[0] : ""}
                  onChange={(e)=>{
                    const value = e.target.value;
                    this.setState(prev=>({
                      eventsFilter:{
                        ...prev.eventsFilter,
                        dateFrom: value ? new Date(value) : undefined
                      }
                    }), this.applyEventFilters)
                  }}
                />
                <Input
                  type="date"
                  style={{ width: "100%", background:"rgba(255,255,255,0.1)", border:"1px solid rgba(255,255,255,0.2)", color:"white" }}
                  value={this.state.eventsFilter.dateTo ? new Date(this.state.eventsFilter.dateTo).toISOString().split('T')[0] : ""}
                  onChange={(e)=>{
                    const value = e.target.value;
                    this.setState(prev=>({
                      eventsFilter:{
                        ...prev.eventsFilter,
                        dateTo: value ? new Date(value) : undefined
                      }
                    }), this.applyEventFilters)
                  }}
                />
                <Button
                  size="small"
                  style={{ width:"100%", background:"#FF4747", color:"white", border:"none" }}
                  onClick={()=>{
                    this.setState(prev=>({
                      eventsFilter:{...prev.eventsFilter, dateFrom:undefined, dateTo:undefined}
                    }),this.applyEventFilters)
                  }}
                > 
                  {language === "de" ? "Zurücksetzen" : "Clear Date"}
                </Button>
              </div>
            </div>

            {/* Filter Mode Section */}
            <div style={{
              flex: "0 0 auto",
              minWidth: "200px",
              padding: "16px",
              background: "rgba(255, 255, 255, 0.05)",
              borderRadius: "6px",
              border: "1px solid rgba(255, 255, 255, 0.1)"
            }}>
              <h4 style={{margin:"0 0 12px 0", fontSize:"14px", fontWeight:500, color:"#87CEEB"}}>{language === "de" ? "Filtermodus" : "Filter Mode"}</h4>
              <Radio.Group
                onChange={(e)=>this.setState(prev=>({
                  eventsFilter:{...prev.eventsFilter, eventFilterType:e.target.value}
                }),this.applyEventFilters)}
                value={this.state.eventsFilter.eventFilterType}
                style={{display:"flex", flexDirection:"column", gap:"8px"}}
              >
                <Radio value="Latest" style={{color:"white", margin:"0"}}>{language === "de" ? "Letztes Update" : "Latest Update"}</Radio>
                <Radio value="By Supervision" style={{color:"white", margin:"0"}}>{language === "de" ? "Letzter Kommentar" : "Latest Comment"}</Radio>
                <Radio value="Oldest" style={{color:"white", margin:"0"}}>{language === "de" ? "Erster Bericht" : "First Report"}</Radio>
              </Radio.Group>
            </div>

            {/* State Section */}

            <div style={{
              flex: "0 0 auto",
              minWidth: "220px",
              padding: "16px",
              background: "rgba(255, 255, 255, 0.05)",
              borderRadius: "6px",
              border: "1px solid rgba(255, 255, 255, 0.1)"
            }}>
              <h4 style={{margin:"0 0 12px 0", fontSize:"14px", fontWeight:500, color:"#87CEEB"}}>{language === "de" ? "Status" : "State"}</h4>
              <div style={{display:"flex", flexDirection:"column", gap:"8px"}}>
                {["active","only report change","do not report"].map((option) => (
                  <Checkbox
                    key={option}
                    checked={this.state.eventsFilter.state.includes(option as any)}
                    onChange={(e) => {
                      const value = e.target.checked
                        ? [...this.state.eventsFilter.state, option as any]
                        : this.state.eventsFilter.state.filter(s => s !== option);
                      this.setState(prev=>({
                        eventsFilter:{...prev.eventsFilter, state:value as ("active" | "only report change" | "do not report")[]}
                      }),this.applyEventFilters);
                    }}
                    style={{color:"white", margin:"0"}}
                  >
                    {getLabel(option)}
                  </Checkbox>
                ))}
              </div>
            </div>

            {/* Detected By Section */}

            <div style={{
              flex: "0 0 auto",
              minWidth: "200px",
              padding: "16px",
              background: "rgba(255, 255, 255, 0.05)",
              borderRadius: "6px",
              border: "1px solid rgba(255, 255, 255, 0.1)"
            }}>
              <h4 style={{margin:"0 0 12px 0", fontSize:"14px", fontWeight:500, color:"#87CEEB"}}>{language === "de" ? "Erkannt durch" : "Detected By"}</h4>
              <div style={{display:"flex", flexDirection:"column", gap:"8px"}}>
                {["Helicopter","Satellite","Drone","Others"].map((option) => (
                  <Checkbox
                    key={option}
                    checked={this.state.eventsFilter.detectedBy.includes(option as any)}
                    onChange={(e) => {
                      const value = e.target.checked
                        ? [...this.state.eventsFilter.detectedBy, option as any]
                        : this.state.eventsFilter.detectedBy.filter(s => s !== option);
                      this.setState(prev=>({
                        eventsFilter:{...prev.eventsFilter, detectedBy:value as ("Helicopter" | "Drone" | "Satellite" | "Others")[]}
                      }),this.applyEventFilters);
                    }}
                    style={{color:"white", margin:"0"}}
                  >
                    {getLabel(option)}
                  </Checkbox>
                ))}
              </div>
            </div>

            {/* Event Type Section */}
            <div style={{
              flex: "1 1 auto",
              minWidth: "220px",
              padding: "16px",
              background: "rgba(255, 255, 255, 0.05)",
              borderRadius: "6px",
              border: "1px solid rgba(255, 255, 255, 0.1)"
            }}>
              <h4 style={{margin:"0 0 12px 0", fontSize:"14px", fontWeight:500, color:"#87CEEB"}}>{language === "de" ? "Event Typ" : "Event type"}</h4>
              <div style={{display:"flex", flexWrap:"wrap", gap:"8px"}}>
                {this.state.types.map((option) => (
                  <Checkbox
                    key={option}
                    checked={this.state.eventsFilter.type.includes(option)}
                    onChange={(e) => {
                      const value = e.target.checked
                        ? [...this.state.eventsFilter.type, option]
                        : this.state.eventsFilter.type.filter(s => s !== option);
                      this.setState(prev=>({
                        eventsFilter:{...prev.eventsFilter, type:value as string[]}
                      }),this.applyEventFilters);
                    }}
                    style={{color:"white", margin:"0"}}
                  >
                    {option}
                  </Checkbox>
                ))}
              </div>
            </div>

            {/* Report Type Section */}
            <div style={{
              flex: "0 0 auto",
              minWidth: "200px",
              padding: "16px",
              background: "rgba(255, 255, 255, 0.05)",
              borderRadius: "6px",
              border: "1px solid rgba(255, 255, 255, 0.1)"
            }}>
              <h4 style={{margin:"0 0 12px 0", fontSize:"14px", fontWeight:500, color:"#87CEEB"}}>{language === "de" ? "Bearbeitet" : "Edited"}</h4>
              <div style={{display:"flex", flexDirection:"column", gap:"8px"}}>
                {["Processed Reports","Edited Reports"].map((option) => (
                  <Checkbox
                    key={option}
                    checked={this.state.eventsFilter.reportType.includes(option as any)}
                    onChange={(e) => {
                      const value = e.target.checked
                        ? [...this.state.eventsFilter.reportType, option as any]
                        : this.state.eventsFilter.reportType.filter(s => s !== option);
                      this.setState(prev=>({
                        eventsFilter:{...prev.eventsFilter, reportType:value as ("Processed Reports" | "Edited Reports")[]}
                      }),this.applyEventFilters);
                    }}
                    style={{color:"white", margin:"0"}}
                  >
                    {getLabel(option)}
                  </Checkbox>
                ))}
              </div>
            </div>
          </div>
        </div>}

        {!isArchivePage && (
          <Button
            onClick={() => {
              exportAsCSV(false);
            }}
          >
            {language === "de" ? "Als CSV exportieren" : "Export as CSV"}
          </Button>
        )}
        <Modal
          title={language === "de" ? "Bearbeiten" : "Edit"}
          className={"events-page-comment" + Style.mapTooltipButton}
          centered
          okText={"Submit"}
          visible={this.state.visible}
          onOk={this.handleOk}
          confirmLoading={this.state.confirmLoading}
          onCancel={this.handleCancel}
          okButtonProps={{
            ...BUTTON_PROPS,
            size: "small",
            disabled:
              !(this.state.currentTypeState == this.state.newTypeState) ||
              !(this.state.currentEventState == this.state.newEventState) ||
              this.state.newEventComment
                ? false
                : true,
          }}
          cancelButtonProps={{
            type: "danger",
            shape: "round",
            size: "small",
            ghost: true,
          }}
          style={{ color: "black" }}
        >
          {stateCommentForm()}
          <UploadImage
            file={this.state.imageFile?.originFileObj as File}
            setFile={this.setFile}
          />
        </Modal>

        {this.state.showEventHistory && (
          <HistoryModal
            eventObject={{
              properties: this.state.historyEvent.properties,
              ...this.state.historyEvent.geometry,
            }}
            eventsData={this.state.locations}
            onClose={() => {
              this.setState({
                showEventHistory: false,
                historyEvent: null,
              });
            }}
            visible={this.state.showEventHistory}
          />
        )}
      </div>
    );
  }
}

const condition = (authUser: IFirebaseAuthUser) =>
  AuthenticationValidatorLogic.isAuthenticated(authUser);

export default withAuthorization(condition)(ROUTES.SIGN_IN.route)(EventsPage);
